export const NOTIFICATION_SET = 'NOTIFICATION_SET';

export const setForm = (key, notification) => ({
    type: NOTIFICATION_SET,
    payload: {
        key, 
        notification,
    }
});